import React from "react";

export { default as BasicDataPanel } from "./BasicDataPanel";
export { default as ITConnectionPanel } from "./ITConnectionPanel";
export { default as ContractorCompanyPanel } from "./ContractorCompanyPanel";
export { CertificationListPanel } from "../wizard/CertificationListForm";
export { UserDeviceListPanel, UserTechDeviceListPanel } from "../../../Device";
export { default as UserRatingPanel } from "./UserRatingPanel";
export { TechKeyListPanel } from "../wizard/TechKeyListForm";

export const TeckKeysPanel = ({ company }) => {
  const techKeys = company.techKeys || [];
  let companyKeyMarkup = (
    <h4>{"Ihnen wurden noch keine technische Schlüssel zugewiesen"}</h4>
  );
  if (techKeys.length > 0) {
    companyKeyMarkup = techKeys.map((key, index) => (
      <div key={index} className="w3-col s3 pad-lr pad-top">
        {key}
      </div>
    ));
    companyKeyMarkup = (
      <div className="w3-row neg-margin-lr">{companyKeyMarkup}</div>
    );
  }
  return companyKeyMarkup;
};
